let demoActive = false;
let originalFetch: typeof fetch | null = null;
let demoUserSnapshot: {
  user?: Record<string, unknown>;
  organization?: Record<string, unknown> | null;
  members?: unknown[];
} | null = null;

const backendBase = process.env.REACT_APP_BACKEND_URL || "";

const isUserEndpoint = (url: string) =>
  url.includes("/vendistri/be/user") ||
  (backendBase && url.includes(`${backendBase}/user`));

const shouldBlockDemoRequest = (url: string) =>
  url.includes("/vendistri/be/") || (backendBase && url.includes(backendBase));

const demoMockResponse = (url: string) => {
  if (!demoUserSnapshot) return {};
  if (url.includes("/user/organization/members")) {
    return { members: demoUserSnapshot.members || [] };
  }
  if (url.includes("/user/organization")) {
    return demoUserSnapshot.organization || {};
  }
  if (isUserEndpoint(url)) {
    return demoUserSnapshot.user || {};
  }
  return {};
};

export const setDemoActive = (active: boolean) => {
  demoActive = active;
  if (typeof window === "undefined") return;
  if (active && !originalFetch) {
    originalFetch = window.fetch.bind(window);
    window.fetch = (input, init) => {
      const url =
        typeof input === "string"
          ? input
          : input instanceof Request
          ? input.url
          : String(input);
      if (demoActive && shouldBlockDemoRequest(url)) {
        return Promise.resolve(
          new Response(JSON.stringify(demoMockResponse(url)), {
            status: 200,
            headers: { "Content-Type": "application/json" },
          })
        );
      }
      return originalFetch!(input, init);
    };
  }
  if (!active && originalFetch) {
    window.fetch = originalFetch;
    originalFetch = null;
  }
};

export const isDemoActive = () => demoActive;

// Authentication must inspect the real cookie even while demo data is active.
export const fetchBrowserSession = (input: RequestInfo | URL, init?: RequestInit) =>
  (originalFetch || window.fetch.bind(window))(input, init);

export const setDemoUserSnapshot = (
  snapshot: typeof demoUserSnapshot
) => {
  demoUserSnapshot = snapshot;
};
